import { oneOf, shape, string } from 'prop-types'

import { ColdChainApiProvider } from '../../models/cold-chain/cold-chain-api-provider-enum'
import { coldChainApiConnectionStatusPropType } from './cold-chain-api-connection-status-prop-type'

/**
 * @typedef {Object} ApiConnection
 * @property {string} apiConnectionId
 * @property {string} provider
 * @property {ApiConnectionStatus} [status]
 */

export const coldChainApiConnectionPropType = shape({
    apiConnectionId: string.isRequired,
    provider: oneOf(Object.values(ColdChainApiProvider)).isRequired,
    status: coldChainApiConnectionStatusPropType
})
